import classNames from 'classnames';
import Link from 'next/link';
import React, { memo } from 'react';

import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { LIST_PARTNERS, LIST_PARTNERS_WITH_TYPE, MFO_LIST_PARTNERS_WITH_TYPE } from '../../../../constants/routes';
import { sliceOrganizationName } from '../../../../helpers/news';
import { IMaterial } from '../../../../interfaces/news';
import { createLinkProps } from '../../../../utils/routing';

import styles from './article-header.module.scss';

export const PartnerLabel = memo(
  ({ organizationData, className }: { organizationData: IMaterial['organizationData']; className?: string }) => {
    const isMobile = useIsMobile();

    if (!organizationData) return null;

    const slicedName = sliceOrganizationName(organizationData.name);
    const isOther = organizationData.type === 'other';

    const { type } = organizationData;
    let organizationTypeForLink = 'strakhovaja-kompanija';
    if (type === 'bank') {
      organizationTypeForLink = 'bank';
    } else if (type === 'mfo') {
      organizationTypeForLink = 'mfo';
    }

    let pattern = LIST_PARTNERS_WITH_TYPE;
    if (isOther) {
      pattern = LIST_PARTNERS;
    } else if (type === 'mfo') {
      pattern = MFO_LIST_PARTNERS_WITH_TYPE;
    }

    const { href, as } = createLinkProps('list', pattern, {
      ...(!isOther && { organizationType: organizationTypeForLink }),
      organizationAlias: organizationData.alias,
    });

    return (
      <Typography.Text size={10} strong uppercase>
        <Link href={href} as={as}>
          <div className={classNames(styles.rubric, className)}>
            {organizationData.logotype && (
              <img
                className={styles.rubricIcon}
                width={20}
                height={20}
                src={organizationData.logotype}
                alt={'Логотип партнёра'}
              />
            )}
            <Typography.Link href={as} color={'black'}>
              {isMobile ? slicedName : organizationData.name}
            </Typography.Link>
          </div>
        </Link>
      </Typography.Text>
    );
  },
);
